import HistoryContextComponent from '../../components/HistoryContextComponent';

export class StationAdapter extends HistoryContextComponent {
    convertToString = (aValue) => aValue.toString();

    toApiSendBoolean = (aFavorites, aSearched) => ({
        favorite: this.convertToString(aFavorites),
        searched: this.convertToString(aSearched)
    });

    toApi = aStation => ({
        ...this.toApiSendBoolean(aStation.favorite, aStation.searched),
        id: aStation.id,
        name: aStation.name,
        station_id: aStation.station_id,
        sound: aStation.sound,
        products: aStation.products,
        longitude: aStation.longitude,
        latitude: aStation.latitude
    });

    convertToBool = (aValue) => aValue && (aValue === 'true');

    fromApiSendBoolean = (aFavorites, aSearched) => ({
        favorite: this.convertToBool(aFavorites),
        searched: this.convertToBool(aSearched)
    });

    fromApi = aStation => ({
        ...this.fromApiSendBoolean(aStation.favorite, aStation.searched),
        id: aStation.id,
        name: aStation.name,
        station_id: aStation.station_id,
        sound: aStation.sound,
        products: aStation.products,
        longitude: aStation.longitude,
        latitude: aStation.latitude
    });
}

export const fromApi = aStation => ({
    favorite: false,
    searched: false,
    id: aStation.s,
    name: aStation.sn,
    station_id: aStation.s,
    sound: aStation.sn,
    products: aStation.p,
    longitude: aStation.lg,
    latitude: aStation.lt
});